import React from 'react';
import { theme } from '../theme/theme';

const Button = ({
  children,
  variant = 'contained',
  color = 'primary',
  size = 'medium',
  disabled = false,
  onClick,
  fullWidth = false,
  startIcon,
  endIcon,
  style = {},
  ...props
}) => {
  const getButtonStyles = () => {
    const baseStyles = {
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.button.fontSize,
      fontWeight: theme.typography.button.fontWeight,
      textTransform: theme.typography.button.textTransform,
      borderRadius: theme.borderRadius.md,
      border: 'none',
      cursor: disabled ? 'not-allowed' : 'pointer',
      transition: `all ${theme.transitions.default}`,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: theme.spacing.sm,
      width: fullWidth ? '100%' : 'auto',
      opacity: disabled ? 0.7 : 1,
    };

    const sizeStyles = {
      small: {
        padding: `${theme.spacing.xs} ${theme.spacing.md}`,
        minHeight: '32px'
      },
      medium: {
        padding: `${theme.spacing.sm} ${theme.spacing.lg}`,
        minHeight: '40px'
      },
      large: {
        padding: `${theme.spacing.md} ${theme.spacing.xl}`,
        minHeight: '48px'
      }
    };

    const variantStyles = {
      contained: {
        background: disabled ? theme.colors.grey[300] : (style.background || theme.colors[color].main),
        color: style.color || theme.colors[color].contrast,
        '&:hover': {
          background: disabled ? theme.colors.grey[300] : (style.background || theme.colors[color].dark),
          boxShadow: theme.shadows.md
        }
      },
      outlined: {
        background: style.background || 'transparent',
        color: style.color || (disabled ? theme.colors.grey[400] : theme.colors[color].main),
        border: `1px solid ${disabled ? theme.colors.grey[300] : theme.colors[color].main}`,
        '&:hover': {
          background: style.background || `${theme.colors[color].main}10`,
          boxShadow: theme.shadows.sm
        }
      },
      text: {
        background: style.background || 'transparent',
        color: style.color || (disabled ? theme.colors.grey[400] : theme.colors[color].main),
        padding: `${theme.spacing.xs} ${theme.spacing.sm}`,
        '&:hover': {
          background: style.background || `${theme.colors[color].main}10`
        }
      }
    };

    return {
      ...baseStyles,
      ...sizeStyles[size],
      ...variantStyles[variant],
      ...style // Apply custom styles last to ensure they override defaults
    };
  };

  return (
    <button
      style={getButtonStyles()}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      {...props}
    >
      {startIcon && <span style={{ display: 'flex' }}>{startIcon}</span>}
      {children}
      {endIcon && <span style={{ display: 'flex' }}>{endIcon}</span>}
    </button>
  );
};

export default Button; 